/* eslint-disable no-param-reassign */
import { useEffect, useRef } from 'react'
import useOutlink from '@hooks/Interface/useOutlink'
import { useIsAppControl } from '@store/isApp'

const useChangeAnchorOutlink = () => {
	const ref = useRef<HTMLDivElement>(null)
	const { isApp } = useIsAppControl()
	const { onLink } = useOutlink()

	useEffect(() => {
		if (!isApp) {
			return () => {}
		}

		const observer = new MutationObserver(() => {
			if (ref.current && ref.current.children.length > 0) {
				Array.from(
					ref.current.querySelectorAll('a[rel="nofollow noopener sponsored"]'),
				).forEach((element) => {
					if (element.getAttribute('href')) {
						const url = element.getAttribute('href')
						element.removeAttribute('href')
						element.removeAttribute('attributionsrc')
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-expect-error
						element.onclick = (e: MouseEvent) => {
							if (!url) {
								return
							}

							e.preventDefault()
							onLink(url)
						}
					}
				})
			}
		})

		if (ref.current) {
			observer.observe(ref.current, {
				childList: true,
				subtree: true,
			})
		}

		return () => {
			observer.disconnect()
		}
	}, [isApp])

	return {
		ref,
	}
}
export default useChangeAnchorOutlink
